import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "grow"
}, null, -1);
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { Team } from "@/modules/team/entity";
import { app } from "@/di";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
export default /*#__PURE__*/_defineComponent({
  __name: 'StartSeasonPage',
  async setup(__props) {
    let __temp, __restore;
    const team = ref();
    const loading = ref(false);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.current();
    })), __temp = await __temp, __restore(), __temp);
    const router = useRouter();
    const onContinue = async () => {
      loading.value = true;
      await waitFor(1000);
      app.get(GlobalResolver).resolvePromise();
    };
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        "hide-tabbar": "",
        "hide-footer": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('new_season')), 1)]),
        subtitle: _withCtx(() => [_createTextVNode(_toDisplayString(team.value.name), 1)]),
        footerButtons: _withCtx(() => [_createVNode(_component_NButton, {
          secondary: "",
          type: "success",
          size: "large",
          loading: loading.value,
          disabled: loading.value,
          onClick: onContinue
        }, {
          default: _withCtx(() => [_createVNode(_component_Icon, {
            icon: _ctx.IconEnum.CheckRound,
            size: "2.5rem"
          }, null, 8, ["icon"])]),
          _: 1
        }, 8, ["loading", "disabled"])]),
        default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('good_luck')), 1), _hoisted_1]),
        _: 1
      });
    };
  }
});